import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import { useRouter } from 'vue-router/composables'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import ExamAction from '@/components/course/course-panel-contents/ExamAction.vue'

  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useSegment from '@/composables/useSegment'

  import UsersApi from '@/services/api/UsersApi'

  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'

  import { DateTime } from 'luxon'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExamDetails',
  emits: ['remove-date'],
  setup(__props) {

  const { course } = useCourse()
  const { translateString } = useI18n()
  const { closeModal, identifyUserInSegmentWithExamDates, downloadItem, showExamAppointmentModal, formatDate } =
    useCommonMixin()
  const { examAppointmentRemoved } = useSegment()

  const router = useRouter()

  

  const { blankCalendar } = useIcons()

  const tipsDownloading = ref(false)
  const tipsDownloaded = ref(false)
  const removingExamDate = ref(false)

  const courseExamAppointment = computed(() => {
    return UserModule.examAppointments?.find((appointment) => appointment.courseId === course.value?.id)
  })

  const examDateActionText = computed(() => {
    if (courseExamAppointment.value) {
      if (tipsDownloaded.value) {
        return translateString('examDatePicker.tipsDownloaded')
      }
      return translateString('examDatePicker.tipsToPrepare')
    }
    return translateString('courses.examSimulation.specifyExamDate')
  })

  const daysLeftToExam = computed(() => {
    if (!courseExamAppointment.value) return 0

    const examDate = DateTime.fromISO(courseExamAppointment.value.date)
    const now = DateTime.now()
    const diff = examDate.diff(now, 'days')
    return Math.ceil(diff.days)
  })

  const examDateHasPassed = computed(() => {
    if (!courseExamAppointment.value) return false
    return daysLeftToExam.value < 0
  })

  const goToExam = () => {
    if (!course.value || !course.value.exam) return
    router.push({ path: `/courses/${course.value.id}/exam/${course.value.exam.id}/start` })
  }

  const handleExamDateActionClick = () => {
    if (courseExamAppointment.value) {
      tipsDownloading.value = true
      downloadExamTipsDocument()

      setTimeout(() => {
        tipsDownloading.value = false
        tipsDownloaded.value = true
      }, 250)
    } else {
      showExamAppointmentModal(course.value!.id)
    }
  }

  const downloadExamTipsDocument = () => {
    if (course.value?.examDateDetails?.examTipsDownloadUrl) {
      downloadItem(course.value?.examDateDetails?.examTipsDownloadUrl)
    }
  }

  const removeExamDate = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'ConfirmationModal',
      modalTitle: translateString('examDatePicker.examDateRemoval'),
      modalProps: {
        confirmationText: translateString('examDatePicker.examDateRemovalConfirmationText'),
        okCallback: triggerRemoveDate,
        cancelButtonText: translateString('cancel'),
      },
      cssClass: 'confirmation',
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }

  const triggerRemoveDate = () => {
    if (removingExamDate.value) return

    removingExamDate.value = true

    UsersApi.cancelExamAppointment(course.value!.id)
      .then(async () => {
        CourseModule.setCourseRealExamDate(null)
        await UserModule.getUser()
        identifyUserInSegmentWithExamDates(course.value?.shortTitle || course.value!.title, null)
        examAppointmentRemoved(course.value!.id, course.value!.title)
      })
      .finally(() => {
        removingExamDate.value = false
        closeModal()
      })
  }

return { __sfc: true,course, translateString, closeModal, identifyUserInSegmentWithExamDates, downloadItem, showExamAppointmentModal, formatDate, examAppointmentRemoved, router, blankCalendar, tipsDownloading, tipsDownloaded, removingExamDate, courseExamAppointment, examDateActionText, daysLeftToExam, examDateHasPassed, goToExam, handleExamDateActionClick, downloadExamTipsDocument, removeExamDate, triggerRemoveDate, computed, ref, useRouter, KetchUpButton, LoadingSpinner, SVGRenderer, ExamAction, useIcons, useCourse, useI18n, useCommonMixin, useSegment, UsersApi, UserModule, CourseModule, DateTime, eventBus }
}

})